import Cookies from 'js-cookie';
import { CookieKey } from '../../constants/cookie';

/** Get passId from cookies */
export const getPassIdCookie = (): string | undefined =>
  Cookies.get(CookieKey.PassId) || Cookies.get(CookieKey.PPassToken);
